import { Controller } from "@hotwired/stimulus"
import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default class extends Controller {
  static targets = ["item"]

  connect() {
    this.revealItems()
    this.setupTurboNavigation()
  }

  setupTurboNavigation() {
    this.turboListener = (event) => {
      if (event.target.id === 'main_content') {
        // Instant scroll to top on navigation
        window.scrollTo(0, 0)

        // Kill existing triggers and re-initialize
        ScrollTrigger.getAll().forEach(trigger => trigger.kill())

        // Wait for DOM to settle, then reinitialize
        requestAnimationFrame(() => {
          this.revealItems()
          ScrollTrigger.refresh()
        })
      }
    }

    document.addEventListener('turbo:frame-load', this.turboListener)
  }

  revealItems() {
    this.itemTargets.forEach((item, index) => {
      // Determine animation direction based on index
      const isEven = index % 2 === 0

      gsap.from(item, {
        scrollTrigger: {
          trigger: item,
          start: "top 85%",
          toggleActions: "play none none none",
          once: true
        },
        x: isEven ? -80 : 80,
        y: 60,
        opacity: 0,
        scale: 0.9,
        rotation: isEven ? -5 : 5,
        duration: 1,
        delay: index * 0.15,
        ease: "back.out(1.5)",
        immediateRender: false,
        clearProps: "rotation",
        onComplete: () => {
          // Add subtle bounce after reveal
          gsap.to(item, {
            y: -5,
            duration: 0.4,
            yoyo: true,
            repeat: 1,
            ease: "power2.inOut"
          })
        }
      })

      // Add hover effect
      item.addEventListener('mouseenter', () => {
        gsap.to(item, {
          scale: 1.05,
          y: -8,
          boxShadow: '0 15px 30px rgba(0,0,0,0.15)',
          duration: 0.4,
          ease: "power2.out"
        })
      })

      item.addEventListener('mouseleave', () => {
        gsap.to(item, {
          scale: 1,
          y: 0,
          boxShadow: '0 0 0 rgba(0,0,0,0)',
          duration: 0.4,
          ease: "power2.out"
        })
      })
    })
  }

  disconnect() {
    // Remove turbo listener
    if (this.turboListener) {
      document.removeEventListener('turbo:frame-load', this.turboListener)
    }

    // Clean up ScrollTrigger instances
    ScrollTrigger.getAll().forEach(trigger => trigger.kill())
  }
}
